import React, { Component } from 'react';
import {connect} from 'react-redux';
import CountryUsers from '../../components/country';
import CountryUsersList from '../../components/country/countryUsers';
import { fetchCountCountryData, getUsers, setDataOnShowMember, disableMember, enableMember} from '../../actions/country';
import {fetchAllMembers, editMember, updateProfile, showTransactionByuserID} from '../../actions/members';

class Counrty extends Component {
  constructor(props){
    super(props)
    this.state={

    };
    this.getUsers = this.getUsers.bind(this);
    this.showCountryList = this.showCountryList.bind(this);
    this.getCountryUsers = this.getCountryUsers.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.showTransactionByuserID = this.showTransactionByuserID.bind(this);
    this.disableMember = this.disableMember.bind(this);
    this.enableMember = this.enableMember.bind(this);
    this.userDemographics = this.userDemographics.bind(this);
  }

  componentWillMount(){
    this.props.dispatch(fetchCountCountryData());
  }

  showCountryList(){
    this.props.dispatch(fetchCountCountryData());
  }

  getUsers(countryData){
    this.props.dispatch(getUsers(countryData.name,1));
    this.props.dispatch(setDataOnShowMember(countryData));
  }

  getCountryUsers(countryName, pageNo){
    this.props.dispatch(getUsers(countryName,pageNo));
  }

  disableMember(id){
    this.props.dispatch(disableMember(id));
  }

  enableMember(data){
    this.props.dispatch(enableMember(data));
  }

  //members

  updateProfile(data){
    this.props.dispatch(updateProfile(data));
  }

  showTransactionByuserID(userId){
    this.props.dispatch(showTransactionByuserID(userId));
  }

  userDemographics( id){
    this.props.history.push('/UserDemographicsCategories/&UID='+id);
  }

  render(){
      let showCountryUsers = '';
    if(this.props.showCountryDataList){
      showCountryUsers =    < CountryUsers
        countryCountSuccess ={this.props.countryCountSuccess}
        countryCountData = {this.props.countryCountData}
        getUsers = {this.getUsers}
      />
    }else if(this.props.showCountryUsersDataList){
      showCountryUsers = <CountryUsersList
      countryUsersSuccess={this.props.countryUsersSuccess}
      countryUsersData ={this.props.countryUsersData}
      showCountryList = {this.showCountryList}
      countryUsersCountData = {this.props.countryUsersCountData}
      getCountryUsers = {this.getCountryUsers}
      updateProfile = {this.updateProfile}
      showTransactionByuserID = {this.showTransactionByuserID}
      UserTranactionSuccess = {this.props.UserTranactionSuccess}
      UserTranactionData = {this.props.UserTranactionData}
      disableMember = {this.disableMember}
      enableMember = {this.enableMember}
      userDemographics = {this.userDemographics}
      />
    }
      
    
  
    return (
        <div> 
           {showCountryUsers}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    showCountryDataList : state.country.showCountryDataList,
    countryCountSuccess : state.country.countryCountSuccess,
    countryCountData    : state.country.countryCountData,
    showCountryUsersDataList : state.country.showCountryUsersDataList,
    countryUsersSuccess : state.country.countryUsersSuccess,
    countryUsersData : state.country.countryUsersData,
    countryUsersCountData : state.country.countryUsersCountData,
    UserTranactionSuccess : state.members.UserTranactionSuccess,
    UserTranactionData : state.members.UserTranactionData,
  }
}

export default connect(mapStateToProps)(Counrty);



// WEBPACK FOOTER //
// ./src/pages/country/index.js